export const useCleanUrl = (url: string | null): string  => {
    return url ? url.replace(/^(https?:\/\/)?(www\.)?/, '') : '';
};